export const getClippingsByTypeNews = (type) => {
    switch (type) {
        case 'normal':
            return { desktop: ["Apertura_full","modal_horizontal_xl"], mobile: ["notification","autos_full"] };  
        case 'schema':
            return { desktop: ["discover","Apertura_full"], mobile: ["share","notification"] };  
        default:
            return { desktop: ["Apertura_full","modal_horizontal_xl"], mobile: ["notification","autos_full"] };   
    }
}